import { PopoverMenuUniDriver } from '@wix/design-system/dist/testkit/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { DisabledTooltipButtonUniDriver } from '../DisabledTooltip/DisabledTooltipButton.uni.driver';

export function CustomFieldPopoverUniDriver(base: UniDriver, body: UniDriver) {
  const customFieldPopoverDriverBase = () =>
    base.$('[data-hook="field-actions-menu"]');

  const customFieldPopoverDriver = () =>
    PopoverMenuUniDriver(customFieldPopoverDriverBase(), body);

  const customFieldOptionsTrigger = () =>
    DisabledTooltipButtonUniDriver(base, body, {
      dataHook: 'field-actions-menu-button',
    });

  const getCustomFieldOptionsAt = () => {
    return {
      open: () => customFieldOptionsTrigger().click(),
      clickEdit: () =>
        customFieldPopoverDriver().clickAtChildByDataHook('field-action-edit'),
      clickArchive: () =>
        customFieldPopoverDriver().clickAtChildByDataHook(
          'field-action-archive',
        ),
    };
  };

  return {
    exists: () => customFieldPopoverDriverBase().exists(),
    isDisabled: () => customFieldOptionsTrigger().isButtonDisabled(),
    getTooltipText: () => customFieldOptionsTrigger().getTooltipText(),
    getCustomFieldOptionsAt,
  };
}
